import React from 'react';
import { MarketSvgProps } from '../market-icons';

const StepTwo: React.FC<MarketSvgProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_997_21610)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.92882 4.92846C8.83399 1.02329 15.1661 1.02343 19.0714 4.92846C22.9766 8.8337 22.9766 15.1658 19.0714 19.071C15.1662 22.9763 8.83406 22.9763 4.92882 19.071C1.0238 15.1658 1.02365 8.83362 4.92882 4.92846ZM17.6573 6.34252C14.5331 3.21854 9.467 3.2184 6.34288 6.34252C3.21876 9.46664 3.21891 14.5328 6.34288 17.657C9.46708 20.7812 14.5331 20.7812 17.6573 17.657C20.7815 14.5328 20.7815 9.46671 17.6573 6.34252Z"
          fill="#101010"
        />
        <path
          d="M9.04826 16V14.404L11.8683 11.836C13.0803 10.744 13.2723 10.456 13.2723 9.89197C13.2723 9.38797 12.8523 8.95597 12.1323 8.95597C11.3523 8.95597 10.8843 9.48397 10.9083 10.384L9.00026 10.108C9.02426 8.42797 10.3443 7.25197 12.1443 7.25197C14.0643 7.25197 15.2763 8.30797 15.2763 9.79597C15.2763 10.816 14.9163 11.428 13.4043 12.748L11.5803 14.284H15.3123V16H9.04826Z"
          fill="#101010"
        />
      </g>
      <defs>
        <clipPath id="clip0_997_21610">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StepTwo;
